export enum RMTRouteType {
  NONE = 'NONE',
  DEFAULT = 'DEFAULT',
}

export enum RMTMode {
  TRANS_MODE_01 = 'TRANS_MODE_01',
  TRANS_MODE_02 = 'TRANS_MODE_02',
  TRANS_MODE_03 = 'TRANS_MODE_03',
  TRANS_MODE_04 = 'TRANS_MODE_04',
  TRANS_MODE_05 = 'TRANS_MODE_05',
  TRANS_MODE_06 = 'TRANS_MODE_06',
  TRANS_MODE_07 = 'TRANS_MODE_07',
  TRANS_MODE_08 = 'TRANS_MODE_08',
  TRANS_MODE_09 = 'TRANS_MODE_09',
}

export enum RMTLocationCategory {
  LOCATION_CAT_01 = 'LOCATION_CAT_01',
  LOCATION_CAT_02 = 'LOCATION_CAT_02',
  LOCATION_CAT_03 = 'LOCATION_CAT_03',
  LOCATION_CAT_04 = 'LOCATION_CAT_04',
  LOCATION_CAT_05 = 'LOCATION_CAT_05',
  LOCATION_CAT_06 = 'LOCATION_CAT_06',
}

export enum RMTMeans {
  // TRANS_MODE_01
  TRANS_MEANS_RAIL_01 = 'TRANS_MEANS_RAIL_01',
  TRANS_MEANS_RAIL_02 = 'TRANS_MEANS_RAIL_02',
  TRANS_MEANS_RAIL_03 = 'TRANS_MEANS_RAIL_03',
  TRANS_MEANS_RAIL_04 = 'TRANS_MEANS_RAIL_04',
  TRANS_MEANS_RAIL_05 = 'TRANS_MEANS_RAIL_05',
  TRANS_MEANS_RAIL_06 = 'TRANS_MEANS_RAIL_06',

  // TRANS_MODE_05
  TRANS_MEANS_RAIL_PASS_01 = 'TRANS_MEANS_RAIL_PASS_01',
  TRANS_MEANS_RAIL_PASS_02 = 'TRANS_MEANS_RAIL_PASS_02',
  TRANS_MEANS_RAIL_PASS_03 = 'TRANS_MEANS_RAIL_PASS_03',
  TRANS_MEANS_RAIL_PASS_04 = 'TRANS_MEANS_RAIL_PASS_04',
  TRANS_MEANS_RAIL_PASS_05 = 'TRANS_MEANS_RAIL_PASS_05',

  // TRANS_MODE_02
  TRANS_MEANS_CAR_01 = 'TRANS_MEANS_CAR_01',
  TRANS_MEANS_CAR_02 = 'TRANS_MEANS_CAR_02',
  TRANS_MEANS_CAR_03 = 'TRANS_MEANS_CAR_03',
  TRANS_MEANS_CAR_04 = 'TRANS_MEANS_CAR_04',
  TRANS_MEANS_CAR_05 = 'TRANS_MEANS_CAR_05',
  TRANS_MEANS_CAR_06 = 'TRANS_MEANS_CAR_06',
  TRANS_MEANS_CAR_07 = 'TRANS_MEANS_CAR_07',
  TRANS_MEANS_CAR_08 = 'TRANS_MEANS_CAR_08',
  TRANS_MEANS_CAR_09 = 'TRANS_MEANS_CAR_09',
  TRANS_MEANS_CAR_10 = 'TRANS_MEANS_CAR_10',
  TRANS_MEANS_CAR_11 = 'TRANS_MEANS_CAR_11',
  TRANS_MEANS_CAR_12 = 'TRANS_MEANS_CAR_12',
  TRANS_MEANS_CAR_13 = 'TRANS_MEANS_CAR_13',
  TRANS_MEANS_CAR_14 = 'TRANS_MEANS_CAR_14',
  TRANS_MEANS_CAR_15 = 'TRANS_MEANS_CAR_15',
  TRANS_MEANS_CAR_16 = 'TRANS_MEANS_CAR_16',
  TRANS_MEANS_CAR_17 = 'TRANS_MEANS_CAR_17',
  TRANS_MEANS_CAR_18 = 'TRANS_MEANS_CAR_18',

  // TRANS_MODE_06
  TRANS_MEANS_CAR_PASS_01 = 'TRANS_MEANS_CAR_PASS_01',
  TRANS_MEANS_CAR_PASS_02 = 'TRANS_MEANS_CAR_PASS_02',
  TRANS_MEANS_CAR_PASS_03 = 'TRANS_MEANS_CAR_PASS_03',
  TRANS_MEANS_CAR_PASS_04 = 'TRANS_MEANS_CAR_PASS_04',
  TRANS_MEANS_CAR_PASS_05 = 'TRANS_MEANS_CAR_PASS_05',
  TRANS_MEANS_CAR_PASS_06 = 'TRANS_MEANS_CAR_PASS_06',
  TRANS_MEANS_CAR_PASS_07 = 'TRANS_MEANS_CAR_PASS_07',
  TRANS_MEANS_CAR_PASS_08 = 'TRANS_MEANS_CAR_PASS_08',
  TRANS_MEANS_CAR_PASS_09 = 'TRANS_MEANS_CAR_PASS_09',
  TRANS_MEANS_CAR_PASS_10 = 'TRANS_MEANS_CAR_PASS_10',

  // TRANS_MODE_07
  TRANS_MEANS_OTHER_01 = 'TRANS_MEANS_OTHER_01',

  // TRANS_MODE_03
  TRANS_MEANS_SEA_01 = 'TRANS_MEANS_SEA_01',
  TRANS_MEANS_SEA_02 = 'TRANS_MEANS_SEA_02',
  TRANS_MEANS_SEA_03 = 'TRANS_MEANS_SEA_03',
  TRANS_MEANS_SEA_04 = 'TRANS_MEANS_SEA_04',
  TRANS_MEANS_SEA_05 = 'TRANS_MEANS_SEA_05',
  TRANS_MEANS_SEA_06 = 'TRANS_MEANS_SEA_06',
  TRANS_MEANS_SEA_07 = 'TRANS_MEANS_SEA_07',
  TRANS_MEANS_SEA_08 = 'TRANS_MEANS_SEA_08',

  // TRANS_MODE_08
  TRANS_MEANS_SEA_PASS_01 = 'TRANS_MEANS_SEA_PASS_01',

  // TRANS_MODE_04
  TRANS_MEANS_AIR_01 = 'TRANS_MEANS_AIR_01',
  TRANS_MEANS_AIR_02 = 'TRANS_MEANS_AIR_02',
  TRANS_MEANS_AIR_03 = 'TRANS_MEANS_AIR_03',

  // TRANS_MODE_09
  TRANS_MEANS_AIR_PASS_01 = 'TRANS_MEANS_AIR_PASS_01',
  TRANS_MEANS_AIR_PASS_02 = 'TRANS_MEANS_AIR_PASS_02',
}

export enum RMTLocationSourceType {
  DATABASE = 'DATABASE',
  CUSTOMIZED = 'CUSTOMIZED',
}

export enum RMType {
  RMA = 'RMA',
  RMT = 'RMT',
}
